<template>
  <div>
    <div class="diaContainer yauto">
      <!-- 报备新增表单 -->
      <el-form
        ref="addReportbForm1"
        :rules="rules"
        :model="addReportbForm"
        v-if="showForm==='showFormReportbAdd'"
        label-position="left"
        label-width="120px"
      >
        <div class="diaForm_box">
          <div class="diaFormTitle">项目信息</div>
          <div style="box-sizing:border-box;padding:0 10%">
            <!-- 项目名称 -->
            <el-form-item label="项目名称" v-if="$store.state.process.finance.isFromProjectBar">
              <span
                style="color:#666;font-size:16px;line-height:40px"
              >{{$store.state.process.finance.projectName}}</span>
            </el-form-item>
            <el-form-item label="项目名称" v-else>
              <!-- <el-select
                style="width:100%"
                v-model="addReportbForm.project_id"
                filterable
                @change="handleProjectSelectChange1"
                @visible-change="handleProjectSelectBlur1"
                :filter-method="projectFilter"
                :disabled="draftDisable"
                multiple
                placeholder="请选择"
              >
                <el-option
                  v-for="(item,num) in projectListSub"
                  style="max-width: 40vw;"
                  :key="item.project_id"
                  :label="item.project_show"
                  :value="item.project_id"
                ></el-option>
                <div
                  v-if="projectList.length > moreNum && projectListSub.length>=moreNum"
                  class="search-keyword-more"
                >只显示前{{moreNum}}条库中结果，请完善搜索关键字</div>
              </el-select>-->
<!--  -->  

<!-- 在本地搜索 -->
              <!-- <el-select
                style="width:100%"
                v-model="addReportbForm.project_id"
                filterable
                @change="handleProjectSelectChange1"
                :disabled="draftDisable"
                multiple
                placeholder="请选择"
              >
                <el-option
                  v-for="(item,num) in projectList"
                  style="max-width: 40vw;"
                  :key="item.project_id"
                  :label="item.project_show"
                  :value="item.project_id"
                ></el-option>
              </el-select> -->

              <!-- 远程搜索 -->
              <el-select
                style="width:100%"
                v-model="addReportbForm.project_id"
                filterable
                remote
                multiple
                @change="handleProjectSelectChange1"
                :disabled="draftDisable"
                :filter-method="projectSearch"
                placeholder="请选择"
              >
                <el-option
                  v-for="(item,num) in projectList"
                  style="max-width: 40vw;"
                  :key="item.project_id"
                  :label="item.project_show"
                  :value="item.project_id"
                ></el-option>
              </el-select>

            </el-form-item>
          </div>
        </div>
        <div class="diaForm_box">
          <div class="diaFormTitle">费用信息</div>
          <div style="box-sizing:border-box;padding:0 10%">
            <!-- 申请人 -->
            <el-form-item label="申请人" style="margin-bottom:0px;" v-if="addReportbForm.member">
              <span
                v-if="addReportbForm.member"
                style="color:#666;font-size:16px"
              >{{addReportbForm.member.nickname}}</span>
            </el-form-item>
            <div
              style="font-size:12px;margin-left:110px;color: rgb(245, 95, 95);margin-bottom:20px;margin-top:0px"
            >*请分条列出事件的发生时间，地点，人物和金额；</div>

            <!-- 预设审批人 -->
            <el-form-item
              label="预设审批人"
              prop="preset_member"
              style="margin-bottom:30px;"
              v-if="$store.state.process.finance.list3.length>0"
            >
              <el-select
                style="width:100%"
                v-model="addReportbForm.preset_member"
                filterable
                :disabled="draftDisable"
                clearable
                placeholder="请选择"
              >
                <el-option
                  v-for="item in $store.state.process.finance.list3"
                  style="max-width: 40vw;"
                  :key="item.member_id"
                  :label="item.nickname"
                  :value="item.member_id"
                ></el-option>
              </el-select>
            </el-form-item>
            <!-- 报备内容 -->
            <el-form-item label="报备内容">
              <el-input
                :disabled="draftDisable"
                placeholder="请输入报备内容"
                v-model="addReportbForm.title"
              ></el-input>
            </el-form-item>
            <!-- 目的地  --  日期 -->
            <div class="inputTwoRow">
              <el-form-item label="开始日期" style="width:50%">
                <el-date-picker
                  :disabled="draftDisable"
                  style="width:100%"
                  v-model="addReportbForm.date"
                  type="date"
                  placeholder="选择日期时间"
                  value-format="yyyy-MM-dd"
                ></el-date-picker>
              </el-form-item>
              <el-form-item label="结束日期" style="width:50%">
                <el-date-picker
                  :disabled="draftDisable"
                  style="width:100%"
                  v-model="addReportbForm.edate"
                  type="date"
                  placeholder="选择日期时间"
                  value-format="yyyy-MM-dd"
                ></el-date-picker>
              </el-form-item>
            </div>
            <!-- 目的地  --  日期 -->
            <div class="inputTwoRow">
              <el-form-item label="预估费用" style="width:50%">
                <el-input
                  :disabled="draftDisable"
                  type="number"
                  placeholder="预估费用"
                  v-model="addReportbForm.total"
                ></el-input>
                <div style="width:40px;text-align:center;line-height:40px;">元</div>
              </el-form-item>
            </div>

            <!-- 备注 -->
            <el-form-item label="备注" style="margin-bottom:20px">
              <el-input
                placeholder="请输入备注信息"
                type="textarea"
                :disabled="draftDisable"
                v-model="addReportbForm.remark"
              ></el-input>
            </el-form-item>
            <!-- 附件 -->
            <el-form-item label="附件" style="margin-bottom:0px">
              <upload-img
                style="width:100%"
                :isSubmit="!draftDisable"
                :imgList="this.imgList"
                :detailsImgList="detailsImgList"
                @my-upload-change="upLoadChange"
              ></upload-img>
            </el-form-item>
          </div>
        </div>
      </el-form>
      <!-- 报备审批表单 -->
      <el-form
        ref="addReportbForm2"
        :rules="rules"
        :model="addReportbForm"
        v-if="showForm==='showFormReportbHandle'"
        label-position="left"
        label-width="120px"
      >
        <div class="diaForm_box diaEditFormBox">
          <div class="ShowFormBtn">
            <el-button
              v-if="addReportbForm.withdraw_status=='1'"
              @click="handleFinnaceWithDraw('Reportb',addReportbForm.id)"
              :disabled="disableLimit"
              class="withdrap"
              style="background-color:rgb(255, 26, 26);"
            >撤回</el-button>
            <el-button
              v-if="addReportbForm.is_just=='1'"
              @click="handleFinnaceApproveWithDraw('Reportb',addReportbForm.id)"
              :disabled="disableLimit"
              class="withdrap"
              style="background-color:rgb(255, 26, 26);"
            >审批撤回</el-button>
            <el-button
              @click="approveVisible=true"
              v-if="addReportbForm.approval_status=='1'"
              class="creat"
              style="background-color:#40A0F2;"
            >去审批</el-button>
          </div>
        </div>
        <div
          class="diaForm_box diaEditFormBox"
          v-if="addReportbForm.is_edit=='1' || (addReportbForm.project_list && addReportbForm.project_list.length>0)"
        >
          <div class="diaFormTitle">项目信息</div>
          <div style="box-sizing:border-box;padding:0 10%">
            <!-- 项目名称 -->
            <el-form-item label="项目名称" v-if="$store.state.process.finance.isFromProjectBar">
              <span
                style="color:#666;font-size:16px;line-height:40px"
              >{{$store.state.process.finance.projectName}}</span>
            </el-form-item>
            <el-form-item label="项目名称" class="containerNoDis" v-else>
              <!-- <el-select
                style="width:100%"
                v-model="addReportbForm.project_id"
                filterable
                v-if="addReportbForm.is_edit=='1'"
                @change="handleProjectSelectChange1"
                @visible-change="handleProjectSelectBlur1"
                :filter-method="projectFilter"
                :disabled="draftDisable"
                multiple
                placeholder="请选择"
              >
                <el-option
                  v-for="(item,num) in projectListSub"
                  style="max-width: 40vw;"
                  :key="item.project_id"
                  :label="item.project_show"
                  :value="item.project_id"
                ></el-option>
                <div
                  v-if="projectList.length > moreNum && projectListSub.length>=moreNum"
                  class="search-keyword-more"
              >只显示前{{moreNum}}条库中结果，请完善搜索关键字</div>-->
              <el-select
                style="width:100%"
                v-model="addReportbForm.project_id"
                filterable
                v-if="addReportbForm.is_edit=='1'"
                @change="handleProjectSelectChange1"
                :disabled="draftDisable"
                multiple
                placeholder="请选择"
              >
                <el-option
                  v-for="(item,num) in projectList"
                  style="max-width: 40vw;"
                  :key="item.project_id"
                  :label="item.project_show"
                  :value="item.project_id"
                ></el-option>
              </el-select>
              <span
                v-else
                class="projectContainerInbox"
                :key="items.project_id"
                v-for="(items,index) in addReportbForm.project_list"
                style="color:#666;font-size:16px;"
              >
                <span
                  class="projectHoverBlue"
                  @click.stop="goProjectDetailsOpenNew(items)"
                  v-if="index<addReportbForm.project_list.length-1"
                >{{items.project_name+','}}</span>
                <span
                  class="projectHoverBlue"
                  @click.stop="goProjectDetailsOpenNew(items)"
                  v-else
                >{{items.project_name }}</span>
              </span>
            </el-form-item>
          </div>
        </div>
        <div class="diaForm_box diaEditFormBox">
          <div class="diaFormTitle">费用信息</div>
          <div style="box-sizing:border-box;padding:0 10%">
            <!-- 申请人 -->
            <el-form-item label="申请人" style="margin-bottom:0px;" v-if="addReportbForm.member">
              <span
                v-if="addReportbForm.member"
                style="color:#666;font-size:16px"
              >{{addReportbForm.member.nickname}}</span>
            </el-form-item>
            <div
              style="font-size:12px;margin-left:110px;color: rgb(245, 95, 95);margin-bottom:20px;margin-top:0px"
            >*请分条列出事件的发生时间，地点，人物和金额；</div>

            <!-- 预设审批人 -->
            <el-form-item
              label="预设审批人"
              prop="preset_member"
              style="margin-bottom:30px;"
              v-if="addReportbForm.is_edit=='1' && $store.state.process.finance.list3.length>0"
            >
              <el-select
                style="width:100%"
                v-model="addReportbForm.preset_member"
                filterable
                :disabled="draftDisable"
                clearable
                placeholder="请选择"
              >
                <el-option
                  v-for="item in $store.state.process.finance.list3"
                  style="max-width: 40vw;"
                  :key="item.member_id"
                  :label="item.nickname"
                  :value="item.member_id"
                ></el-option>
              </el-select>
            </el-form-item>
            
            <!-- 报备内容 -->
            <el-form-item label="报备内容">
              <el-input
                placeholder="请输入报备内容"
                v-model="addReportbForm.title"
                v-if="addReportbForm.is_edit=='1'"
              ></el-input>
              <span style="color:#666;font-size:16px" v-else>{{addReportbForm.title}}</span>
            </el-form-item>
             <!-- 目的地  --  日期 -->
            <div class="inputTwoRow">
              <el-form-item label="开始日期" style="width:50%">
                <el-date-picker
                  style="width:100%"
                  v-model="addReportbForm.date"
                  type="date"
                  placeholder="选择日期时间"
                  value-format="yyyy-MM-dd"
                  v-if="addReportbForm.is_edit=='1'"
                ></el-date-picker>
                <span v-else style="color:#666;font-size:16px">{{addReportbForm.date}}</span>
              </el-form-item>
              <el-form-item label="结束日期" style="width:50%">
                <el-date-picker
                  style="width:100%"
                  v-model="addReportbForm.edate"
                  type="date"
                  placeholder="选择日期时间"
                  value-format="yyyy-MM-dd"
                  v-if="addReportbForm.is_edit=='1'"
                ></el-date-picker>
                <span v-else style="color:#666;font-size:16px">{{addReportbForm.edate}}</span>
              </el-form-item>
            </div>
            <!-- 目的地  --  日期 -->
            <div class="inputTwoRow">
              <el-form-item label="预估费用" style="width:50%">
                <el-input
                  v-if="addReportbForm.is_edit=='1'"
                  type="number"
                  placeholder="预估费用"
                  v-model="addReportbForm.total"
                ></el-input>
                <div
                  v-if="addReportbForm.is_edit=='1'"
                  style="width:40px;text-align:center;line-height:40px;"
                >元</div>
                <span v-else style="color:#666;font-size:16px">{{addReportbForm.total}}</span>
              </el-form-item>
            </div>

            <!-- 备注 -->
            <el-form-item label="备注" style="margin-bottom:20px">
              <el-input
                placeholder="请输入备注信息"
                type="textarea"
                v-if="addReportbForm.is_edit=='1'"
                v-model="addReportbForm.remark"
              ></el-input>
              <el-input
                type="textarea"
                class="onlyShowText"
                disabled
                autosize
                v-else
                v-model="addReportbForm.remark"
              ></el-input>
            </el-form-item>

            <!-- 附件 -->
            <el-form-item label="附件" style="margin-bottom:20px">
              <upload-img
                :isSubmit="addReportbForm.is_edit=='1'"
                :imgList="this.imgList"
                :detailsImgList="detailsImgList"
                @my-upload-change="upLoadChange"
              ></upload-img>
            </el-form-item>
          </div>
        </div>

        <div class="diaForm_box diaEditFormBox">
          <div class="diaFormTitle">审批信息</div>
          <div style="box-sizing:border-box;padding:0 10%">
            <!-- 已通过 -->
            <el-timeline>
              <el-timeline-item
                v-for="(activity, index) in addReportbForm.approval_log"
                :color="activity.approval_status==0?'':'#128bf1'"
                :key="index"
              >
                <div style="margin-bottom:5px">
                  <span>提交人:</span>
                  <span>{{activity.memberInfo.nickname}}</span>
                  <span style="margin:0 10px;color:rgb(18, 139, 241)">提交</span>
                  <span>{{activity.add_time}}</span>
                </div>
                <div>
                  <span
                    v-if="activity.approval_status=='1'"
                    style="margin-right:10px"
                  >{{activity.executorInfo.nickname}}</span>
                  <span v-if="activity.approval_status=='1'" style="color:rgb(18, 139, 241)">通过</span>
                  <span
                    v-if="activity.approval_status=='-1'"
                    style="margin-right:10px"
                  >{{activity.executorInfo.nickname}}</span>
                  <span v-if="activity.approval_status=='-1'" style="color:rgb(255, 51, 51)">驳回</span>
                  <span
                    v-if="activity.approval_status=='-2'"
                    style="margin-right:10px"
                  >{{activity.executorInfo.nickname}}</span>
                  <span v-if="activity.approval_status=='-2'" style="color:rgb(255, 51, 51)">审批撤回</span>
                  <span
                    v-if="activity.approval_status=='0'"
                    v-for="item in activity.tomemberInfo"
                    style="margin-right:10px"
                  >{{item.nickname+' '}}</span>
                  <span v-if="activity.approval_status=='0'" style="color:rgb(255, 51, 51)">待审批</span>
                  <span
                    style="margin-left:10px"
                    v-if="activity.update_time"
                  >{{activity.update_time}}</span>
                </div>
                <div class="remark" style="margin-top:5px" v-if="activity.remark">
                  <span style="margin-right:5px">备注:</span>
                  <span style="color:rgb(255, 51, 51)">{{activity.remark}}</span>
                </div>
              </el-timeline-item>
            </el-timeline>
          </div>
        </div>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer">
      <!-- 报备新增按钮 -->
      <el-button
        style="background-color: #ccc;"
        v-if="showForm==='showFormReportbAdd' && addReportbForm.is_draft!='1'"
        @click="handleAddReportbSubmit('1')"
        :disabled="disableLimit"
      >保存草稿</el-button>
      <el-button
        type="primary"
        v-if="showForm==='showFormReportbAdd' && addReportbForm.is_draft!='1'"
        @click="handleAddReportbSubmit('0')"
        :disabled="disableLimit"
      >提 交</el-button>
      <!-- 报备编辑按钮 -->
      <el-button
        style="background-color: #ccc;"
        v-if="showForm==='showFormReportbAdd' && addReportbForm.is_draft=='1' && !draftDisable"
        @click="handleEditReportbSubmit('1')"
        :disabled="disableLimit"
      >保存草稿</el-button>
      <el-button
        type="primary"
        v-if="showForm==='showFormReportbAdd' && addReportbForm.is_draft=='1' && !draftDisable"
        @click="handleEditReportbSubmit('0')"
        :disabled="disableLimit"
      >提 交</el-button>
      <!-- 报备重新提交按钮 -->
      <el-button
        style="background-color: #ccc;"
        v-if="showForm==='showFormReportbHandle' && addReportbForm.is_edit=='1'"
        @click="getDialogVisible(false)"
      >取 消</el-button>
      <el-button
        type="primary"
        v-if="showForm==='showFormReportbHandle' && addReportbForm.is_edit=='1'"
        @click="handleEditReportbSubmit('0')"
        :disabled="disableLimit"
      >提 交</el-button>
      <!-- 签名组件 -->
    </div>
    <sign-dialog
      @wirtDoen="handleWriteDone"
      :visible.sync="receiverSignFlag"
      @change="handleReceiverSign"
    ></sign-dialog>
    <!-- 弹窗--审批 -->
    <el-dialog
      :visible.sync="approveVisible"
      width="60%"
      class="addClientDia"
      :before-close="approveVisibleClose"
      append-to-body
      @close="approveVisibleClosed"
      :modal-append-to-body="false"
      v-dialogDrag
    >
      <div slot="title" class="header-title">
        <span class="title-age">审批</span>
      </div>
      <div>
        <el-form ref="form" label-position="right" label-width="160px">
          <div class="diaForm_box diaEditFormBox">
            <div
              v-if="addReportbForm.approval_status=='1'"
              style="font-size:12px;padding-right:30px;text-align:right;color: rgb(245, 95, 95);margin-bottom:20px;margin-top:0px"
            >*您可以选择驳回后发起人提交的节点</div>
            <!-- 自动审批大通按钮 -->
            <el-form-item label="自动审批" v-if="addReportbForm.approval_status=='1'">
              <div style="height:40px;display:flex;align-items:center;">
                <el-switch
                  active-value="1"
                  inactive-value="0"
                  v-model="is_chase"
                  active-color="#128bf1"
                  inactive-color="#ccc"
                ></el-switch>
              </div>
            </el-form-item>
            <el-form-item label="驳回节点" v-if="addReportbForm.approval_status=='1'">
              <el-select style="width:95%" v-model="k_code" placeholder="请选择" clearable>
                <el-option
                  style="max-width: 40vw;"
                  v-for="(item,index) in addReportbForm.stage_selectArry"
                  :key="item.id"
                  :value="item.id"
                  :label="item.label"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="审批备注" v-if="addReportbForm.approval_status=='1'">
              <el-input
                style="width:95%"
                placeholder="审批备注"
                type="textarea"
                v-model="approvalRemark"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="签名"
              v-if="addReportbForm.approval_status=='1'"
              style="margin-bottom:20px"
            >
              <img
                v-if="!sign_pic"
                @click="handleReceiverFlag"
                style="width:66px;height:66px;"
                src="../../../assets/image/zaixianqianm@2x.png"
                alt
              />
              <img
                v-if="sign_pic"
                @click="handleReceiverFlag(sign_pic)"
                style="width:66px;height:66px;"
                :src="sign_pic"
                alt
              />
            </el-form-item>
          </div>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button
          v-if="addReportbForm.approval_status=='1'"
          @click="handleFinnaceApproval('-1','Reportb',addReportbForm.id)"
          :disabled="disableLimit"
          style="background:#f4a029;"
          class="search"
        >驳回</el-button>
        <el-button
          v-if="addReportbForm.approval_status=='1'"
          @click="handleFinnaceApproval('1','Reportb',addReportbForm.id)"
          :disabled="disableLimit"
          class="creat"
          style="background-color:#40A0F2;"
        >通过</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { mapState, mapGetters, mapMutations } from 'vuex'
import UploadImg from '../../../components/UploadImg'
import SignDialog from '../../../components/SignDialog'

import 'viewerjs/dist/viewer.css'
import { api as viewerApi } from 'v-viewer'

export default {
  data() {
    return {
      approveVisible: false,
      sign_pic: '',
      receiverSignFlag: false,
      // 禁用按钮防抖
      disableLimit: false,

      imgList: [],
      detailsImgList: [],

      k_code: '',
      token: '',
      member_id: '',
      company_id: '',
      cache_department_id: '',
      tiemID1: null,
      timeDou: 100,
      // 新增报备
      addReportbForm: {
        project_list: [],
        type: '1',
        title: '',
        destination: '',
        date: '',
        edate: '',
        driving_range: '',
        driving_mileage: 0.0,
        driving_expenses: '',
        hotel: 0.0,
        traffic: 0.0,
        food_bill: 0.0,
        other: 0.0,
        total: '',
        remark: '',
        annex: '',
        project_id: [],
        bill: '',
        no_bill: '',

      

      },
      approvalRemark: '',
      // 自动审批大通
      is_chase: '0',
      rules: {
        preset_member: [
          { required: true, message: '请选择预设审批人', trigger: 'change' },
        ],
      },


      project_search_list:[]
    }
  },
  props: [],
  components: {
    UploadImg,
    SignDialog,
  },
  watch: {
    '$store.state.process.finance.formData'(newval, olval) {
      this.addReportbForm = newval
    },
    '$store.state.process.finance.dialogVisible'(newval, olval) {
      if (newval == false) {
        this.is_chase = '0'
      }
    },
    'addReportbForm.annex': {
      handler: function (val, oldVal) {
        this.imgList = val
        this.detailsImgList = val
      },
    },
    // 默认驳回节点是当前节点
    'addReportbForm.stage_selectArry': {
      handler: function (val, oldVal) {
        if (val && val.length > 0) {
          this.k_code = val[val.length - 1].id
          console.log('this.k_code', this.k_code)
        } else {
          this.k_code = ''
        }
      },
    },
  },
  methods: {
   // 按搜索条件查找，不在本地进行查找
  async projectSearch(val){
   if(!val)return
   console.log(val)
    let param = new FormData()
      param.append('member_id', localStorage.getItem('btlh_process_member_id') || '')
      param.append('token', localStorage.getItem('btlh_process_token') || '')
      
      param.append('cache_department_id', localStorage.getItem('bthl_process_cache_department_id_store') || '')
      param.append('company_id', localStorage.getItem('bthl_process_LoginCompanyId') || '')
      param.append('type', '1')
      param.append('search', val)
      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Project/simple_project',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      console.log(res.datas.listInfo)
      this.$store.commit(
        'process/finance/assignmentProject',
        res.datas.listInfo
      )
      if (res.datas.listInfo.length > this.moreNum) {
        this.$store.commit(
          'process/finance/setprojectListSub',
          res.datas.listInfo.slice(0, this.moreNum)
        )
      } else {
        this.$store.commit(
          'process/finance/setprojectListSub',
          res.datas.listInfo
        )
      }
      console.log('获取项目列表', this.$store.state.process.finance.projectList)
     
   },


    handleTypeChange(val) {
      if (this.draftDisable) {
        return
      }
      this.addReportbForm.type = val
    },
    ...mapMutations('process/finance', ['getDialogVisible', 'userFilter']),
    projectFilter(query = '') {
      let arr = this.projectList.filter((item) => {
        return (
          item.project_id.includes(query) || item.project_show.includes(query)
        )
      })
      console.log('arr', arr)
      if (arr.length == 0) {
        this.$forceUpdate()
      }
      if (arr.length > this.moreNum) {
        this.$store.commit(
          'process/finance/setprojectListSub',
          arr.slice(0, this.moreNum)
        )
      } else {
        this.$store.commit('process/finance/setprojectListSub', arr)
      }
    },
    handleProjectSelectBlur1(val) {
      if (!val) {
        if (this.projectList.length > this.moreNum) {
          this.$store.commit(
            'process/finance/setprojectListSub',
            this.projectList.slice(0, this.moreNum)
          )
        } else {
          this.$store.commit(
            'process/finance/setprojectListSub',
            this.projectList
          )
        }

        console.log('this.projectListSub', this.projectListSub)
      }
    },
    handleReceiverFlag(url) {
      this.receiverSignFlag = true
    },
    handleWriteDone(data) {
      this.sign_pic = data
    },
    handleReceiverSign() {},

    // 点击新窗口打开项目页面
    goProjectDetailsOpenNew(items) {
      console.log('items', items)
      // this.$router.resolve({
      //   path: '/project/details/task',
      //   query: {
      //     project_id: items.project_id,
      //     project_name: items.project_name,
      //     isEdit: '1',
      //   },
      // })
      let routeUrl = this.$router.resolve({
        path: '/project/details/task',
        query: {
          project_id: items.project_id,
          project_name: items.project_name,
          isEdit: '1',
          formFinance: '1',
          project_status: '',
        },
      })
      window.open(routeUrl.href)
    },
    upLoadChange(data) {
      this.imgList = data
    },
    // *审批撤回
    async handleFinnaceApproveWithDraw(stage_code, finance_id) {
      this.disableLimit = true
      let param = new URLSearchParams()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', this.cache_department_id)
      param.append('company_id', this.company_id)

      param.append('finance_id', finance_id)
      param.append('stage_code', stage_code)

      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Management/finance_approve_withdraw',
        data: param,
      })
      if (res.code != 200) {
        this.disableLimit = false
        return this.$message.error(res.datas.msg)
      }
      this.disableLimit = false
      this.$message.success(res.datas.msg)

      this.getList()
      if (this.$route.path == '/myFlow') {
        this.$store.commit('process/myFlow/get_finnace_coming_list_mutation')
      }
      this.getDialogVisible(false)
    },
    // *撤回
    async handleFinnaceWithDraw(stage_code, finance_id) {
      this.disableLimit = true
      let param = new URLSearchParams()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', this.cache_department_id)
      param.append('company_id', this.company_id)

      param.append('finance_id', finance_id)
      param.append('stage_code', stage_code)

      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Finance/withdraw',
        data: param,
      })
      if (res.code != 200) {
        this.disableLimit = false
        return this.$message.error(res.datas.msg)
      }
      this.disableLimit = false
      this.$message.success(res.datas.msg)

      this.getList()
      if (this.$route.path == '/myFlow') {
        this.$store.commit('process/myFlow/get_finnace_coming_list_mutation')
      }
      this.getDialogVisible(false)
    },
    // *财务审批(详情页点击通过或驳回)
    async handleFinnaceApproval(val, stage_code, finance_id) {
      this.disableLimit = true
      let param = new URLSearchParams()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', this.cache_department_id)
      param.append('company_id', this.company_id)

      param.append('finance_id', finance_id)
      param.append('stage_code', stage_code)

      param.append('approval_status', val)
      param.append('remark', this.approvalRemark)
      param.append('k_code', this.k_code)
      param.append('is_chase', this.is_chase)

      param.append('sign_pic', this.sign_pic)

      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Management/finance_approval',
        data: param,
      })
      if (res.code != 200) {
        this.disableLimit = false
        return this.$message.error(res.datas.msg)
      }
      this.$message.success(res.datas.msg)
      this.disableLimit = false
      // 清空驳回节点
      this.k_code = ''
      this.sign_pic = ''
      this.approvalRemark = ''
      this.getList()
      if (this.$route.path == '/myFlow') {
        this.$store.commit('process/myFlow/get_finnace_coming_list_mutation')
      }
      this.getDialogVisible(false)
      this.approveVisible = false
    },

    // *编辑报备提交
    async handleEditReportbSubmit(val) {
      if (this.$store.state.process.finance.list3.length > 0) {
        // 判断是不是草稿
        if (this.addReportbForm.is_draft == '1') {
          this.$refs.addReportbForm1.validate(async (valid) => {})
        } else {
          this.$refs.addReportbForm2.validate(async (valid) => {})
        }
      }
      this.disableLimit = true
      if (this.addReportbForm.date == null) {
        this.addReportbForm.date = ''
      }

      clearTimeout(this.tiemID1)
      this.tiemID1 = setTimeout(async () => {
        // return console.log(
        //   'addReportbForm.project_id',
        //   this.addReportbForm.isOld_project_id
        // )
        let param = new FormData()
        param.append('member_id', this.member_id)
        param.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          param.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          param.append('device', 'pc')
        }
        param.append('cache_department_id', this.cache_department_id)
        param.append('company_id', this.company_id)
        param.append('is_draft', val)
        param.append('finance_id', this.addReportbForm.id)

        param.append('preset_member', this.addReportbForm.preset_member)

        param.append('type', this.addReportbForm.type)
        param.append('title', this.addReportbForm.title)
        param.append('destination', this.addReportbForm.destination)
        param.append('date', this.addReportbForm.date)
        param.append('edate', this.addReportbForm.edate)
        param.append('driving_range', this.addReportbForm.driving_range)
        param.append(
          'driving_mileage',
          this.addReportbForm.driving_mileage
        )
        param.append('driving_expenses', this.driveMoney)
        param.append('hotel', this.addReportbForm.hotel)
        param.append('traffic', this.addReportbForm.traffic)
        param.append('food_bill', this.addReportbForm.food_bill)
        param.append('other', this.addReportbForm.other)
        param.append('total', this.addReportbForm.total)

        param.append('bill', this.addReportbForm.bill)
        param.append('no_bill', this.no_bill)
        param.append('remark', this.addReportbForm.remark)
        param.append('annex', JSON.stringify(this.imgList))
        // // 单选
        // if (
        //   Array.isArray(this.addReportbForm.isOld_project_id) &&
        //   !this.addReportbForm.project_id
        // ) {
        //   param.append(
        //     'project_id',
        //     this.addReportbForm.isOld_project_id.join(',')
        //   )
        // } else {
        //   param.append('project_id', this.addReportbForm.project_id)
        // }
        // 多选
        // param.append(
        //   'project_id',
        //   this.addReportbForm.project_id.join(',')
        // )
        if (this.$store.state.process.finance.isFromProjectBar) {
          param.append(
            'project_id',
            this.$store.state.process.finance.projectId
          )
        } else {
          param.append(
            'project_id',
            this.addReportbForm.project_id.join(',')
          )
        }

        const { data: res } = await this.$axios({
          method: 'post',
          url: '/api/Finance/Reportb_edit',
          data: param,
        })
        if (res.code != 200) {
          this.disableLimit = false
          return this.$message.error(res.datas.msg)
        }
        this.$message.success(res.datas.msg)
        this.disableLimit = false

        this.getList()
        if (this.$route.path == '/myFlow') {
          this.$store.commit('process/myFlow/get_finnace_coming_list_mutation')
        }
        this.getDialogVisible(false)
      }, this.timeDou)
    },

    // *报备点击提交
    async handleAddReportbSubmit(val) {
      if (this.$store.state.process.finance.list3.length > 0) {
        this.$refs.addReportbForm1.validate(async (valid) => {
          //   如果校验失败
          // if (valid == false) return this.$message.error('角色信息不合规')
          // 如果校验成功
        })
      }

      this.disableLimit = true
      if (this.addReportbForm.date == null) {
        this.addReportbForm.date = ''
      }
      clearTimeout(this.tiemID1)
      this.tiemID1 = setTimeout(async () => {
        let param = new FormData()
        param.append('member_id', this.member_id)
        param.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          param.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          param.append('device', 'pc')
        }
        param.append('cache_department_id', this.cache_department_id)
        param.append('company_id', this.company_id)
        param.append('is_draft', val)

        param.append('preset_member', this.addReportbForm.preset_member)

        param.append('type', this.addReportbForm.type)
        param.append('title', this.addReportbForm.title)
        param.append('destination', this.addReportbForm.destination)
        param.append('date', this.addReportbForm.date)
        param.append('edate', this.addReportbForm.edate)
        param.append('driving_range', this.addReportbForm.driving_range)
        param.append(
          'driving_mileage',
          this.addReportbForm.driving_mileage
        )
        param.append('driving_expenses', this.driveMoney)
        param.append('hotel', this.addReportbForm.hotel)
        param.append('traffic', this.addReportbForm.traffic)
        param.append('food_bill', this.addReportbForm.food_bill)
        param.append('other', this.addReportbForm.other)
        param.append('total', this.addReportbForm.total)

        param.append('bill', this.addReportbForm.bill)
        param.append('no_bill', this.no_bill)
        param.append('remark', this.addReportbForm.remark)
        param.append('annex', JSON.stringify(this.imgList))
        // 多选
        // param.append(
        //   'project_id',
        //   this.addReportbForm.project_id.join(',')
        // )
        // // 单选
        // param.append('project_id', this.addReportbForm.project_id)
        if (this.$store.state.process.finance.isFromProjectBar) {
          param.append(
            'project_id',
            this.$store.state.process.finance.projectId
          )
        } else {
          param.append(
            'project_id',
            this.addReportbForm.project_id.join(',')
          )
        }

        const { data: res } = await this.$axios({
          method: 'post',
          url: '/api/Finance/Reportb_add',
          data: param,
        })
        if (res.code != 200) {
          this.disableLimit = false
          return this.$message.error(res.datas.msg)
        }
        this.$message.success(res.datas.msg)
        this.disableLimit = false
        this.getList()
        if (this.$route.path == '/myFlow') {
          this.$store.commit('process/myFlow/get_finnace_coming_list_mutation')
        }
        this.getDialogVisible(false)
      }, this.timeDou)
    },
    getList() {
      if (this.$store.state.process.finance.isFromProjectBar) {
        this.$store.commit(
          'process/finance/getReportbList',
          this.$store.state.process.finance.projectId
        )
        this.$store.commit(
          'process/finance/getFinanceSildeBarNum',
          this.$store.state.process.finance.projectId
        )
      } else {
        this.$store.commit('process/finance/getReportbList')
      }
    },
    // 选择项目名称1
    async handleProjectSelectChange1(val) {
     console.log('val',val)
     console.log(this.addReportbForm)
      if (val && val.length > 1) {
        this.$message.error('关联项目只能选择1个')
        this.addReportbForm.project_id = [val[0]]
      }
      // 强制刷新组件
      this.$forceUpdate()
    },
    approveVisibleClose() {
      this.approveVisible = false
    },
    approveVisibleClosed() {
      this.is_chase = '0'
      this.k_code = ''
      this.approvalRemark = ''
      this.sign_pic = ''
    },
  },

  async created() {
    this.addReportbForm = JSON.parse(
      JSON.stringify(this.$store.state.process.finance.formData)
    )
    if (this.addReportbForm.annex) {
      this.imgList = this.addReportbForm.annex
      this.detailsImgList = this.addReportbForm.annex
    }
    this.disableLimit = false
    this.token = localStorage.getItem('btlh_process_token') || ''
    this.member_id = localStorage.getItem('btlh_process_member_id') || ''
    // alert(this.member_id)
    this.company_id = localStorage.getItem('bthl_process_LoginCompanyId') || ''
    this.cache_department_id =
      localStorage.getItem('bthl_process_cache_department_id_store') || ''
  },
  mounted() {},
  computed: {
    ...mapState('process/finance', [
      'showForm',
      'draftDisable',
      'formData',
      'moreNum',
      'projectList',
      'projectListSub',
    ]),
    // 总计
    sumMoney() {
      var dMoney = parseFloat(
        (this.addReportbForm.driving_mileage * 1.25).toFixed(2)
      )
      console.log('dMoney1', dMoney)
      return (
        dMoney +
        this.addReportbForm.hotel * 1.0 +
        this.addReportbForm.traffic * 1.0 +
        this.addReportbForm.food_bill * 1.0 +
        this.addReportbForm.other * 1.0
      ).toFixed(2)
    },
    // 开车费用
    driveMoney() {
      return (this.addReportbForm.driving_mileage * 1.25).toFixed(2)
    },
    //无发票账单
    // no_bill() {
    //   var dMoney = parseFloat(
    //     (this.addReportbForm.driving_mileage * 1.25).toFixed(2)
    //   )
    //   console.log('dMoney1', dMoney)
    //   return (
    //     dMoney +
    //     this.addReportbForm.hotel * 1.0 +
    //     this.addReportbForm.traffic * 1.0 +
    //     this.addReportbForm.food_bill * 1.0 +
    //     this.addReportbForm.other * 1.0-
    //     this.addReportbForm.bill
    //   ).toFixed(2)
    // },
  },
}
</script>
<style lang="less" scoped>
@import url(../../../views/topBar/finance.scss);
.search-keyword-more {
  width: 100%;
  text-align: center;
  font-size: 14px;
  color: #999;
}
</style>